export const ROUTES = {
  LOGIN: "/login",
  FORGOT_PASSWORD: "/forgotpassword",
  CHANGE_PASSWORD: "/resetPassword/:userid/:token",
  SIGNUP: "/signup/:id?",
  WELCOME: "/welcome",
  DASHBOARD: "/dashboard/*",
  POLICIES: "/policies",

  //survey redirects
  SURVEY_REDIRECT: "/survey-redirect",
  SURVEY_REDIRECT_OVERQUOTA: "/survey-failure-overquota",
  SURVEY_REDIRECT_SECURITY: "/survey-security-term",
  SURVEY_REDIRECT_TERMINATED: "/survey-failure-terminated",

  // Toluna Survey Redirect
  TOLUNA_QUALIFIED: "/surveys/toluna/qualified",
  TOLUNA_NOT_QUALIFIED: "/surveys/toluna/not-qualified",
  TOLUNA_QUOTA_FULL: "/surveys/toluna/quota-full",
  TOLUNA_FRAUD_TERMINATE: "/surveys/toluna/fraud-terminate",
  TOLUNA_TERMINATED: "/surveys/toluna/terminated",
  TOLUNA_MAX_SURVEYS_REACHED: "/surveys/toluna/max-surveys-reached",
  TOLUNA_NO_SURVEYS: "/surveys/toluna/no-surveys",
  TOLUNA_NO_COOKIES: "/surveys/toluna/no-cookies",
  TOLUNA_SURVEY_NOT_AVAILABLE: "/surveys/toluna/survey-not-available",
  TOLUNA_SURVEY_TAKEN: "/surveys/toluna/survey-taken",
};

export const PRELOGIN_INDEX = {
  LOGIN: 0,
  FORGOT_PASSWORD: 1,
  CHANGE_PASSWORD: 2,
  SIGNUP: 3,
};

export const EMAIL_REGEX = /^[\w-\\.+]+@([\w-]+\.)+[\w-]{2,4}$/g;

export const GENDERS = ["Male", "Female", "Others"];

export const ETHNICITY = [
  "Asian",
  "Black or African American",
  "Hispanic or Latino",
  "Native American or Alaska Native",
  "Native Hawaiian or Other Pacific Islander",
  "White",
  "Middle Eastern or North African",
  "Multiracial or Biracial",
  "Other",
  "Prefer not to say",
];

export const MARRIAGE_STATUS = [
  "Single",
  "Married",
  "Divorced",
  "Widowed",
  "Separated",
  "Domestic Partnership",
];

export const SUPPORT_CATEGORIES = ["My Orders", "My Earnings"];

export const DASHBOARD_ROUTES = {
  TASKS: "surveys",
  MY_WALLET: "mywallet",
  MY_ORDERS: "orders",
  REDEEM: "redeem",
  CART: "cart",
  REFER_USERS: "referal",
  NOTIFICATIONS: "notifications",
  SUPPORT: "support",
  PROFILE_SETTINGS: "profile",
  LOGOUT: "logout",
  SURVEY_PROFILE: "surveyprofile",
  BANNER_SURVEYS: "bannersurveys",
  APPS: "apps",
  SHOPPING: "shopping",
};

export const DASHBOARD_DEFAULT_ROUTE = "/dashboard/" + DASHBOARD_ROUTES.TASKS;

export const SNACKBAR_AUTO_DISMISS_DURATION_MS = 5000;

export const TOTAL_STAR_USER_LEVELS = 8;
export const MAX_SURVEYS_IN_DASHBOARD = 10;
export const DEFAULT_TERMS_CHARS_TO_SHOW = 150;

export const DEFAULT_PAGE = 0;
export const DEFAULT_ROWS_PER_PAGE = 10;
export const DEFAULT_ROW_OPTIONS_PER_PAGE = [10, 25, 50, 100];

export const DEFAULT_REDEEM_ROWS_PER_PAGE = 24;
export const REDEEM_ROW_OPTIONS_PER_PAGE = [24, 48];

export const STORAGE_TOKEN = "token";
export const STORAGE_REFRESH_TOKEN = "refreshToken";
export const STORAGE_IS_FIRST_LOGIN = "isFirstLogin";
export const STORAGE_IS_INITIAL_SURVEY = "initialSurvey";
export const STORAGE_IS_SURVEY_BLOCK = "isSurveyBlock";
export const STORAGE_IS_POPUP_SHOWN = "ispopupshown";
export const STORAGE_IS_MATCH_POPUP_SHOWN = "ismatchpopupshown";
export const STORAGE_SELECTED_MENU = "selected_menu";
export const STORAGE_USERID = "userid";
export const STORAGE_USER_ID = "user_id";

export const SURVEY_STATUS_COMPLETED = "Completed";
export const SURVEY_STATUS_ASSIGNED = "Assigned";

export const DOB_FORMAT = "DD/MM/YYYY";
export const SURVEY_DATE_FORMAT = "dd/MM/yyyy";
export const EARNINGS_DATE_FORMAT = "dd/MM/yyyy";
export const DEFAULT_PLACEAHOLDER = "-";

export const MENU_ITEM_PROFILE_SETTINGS = 0;
export const MENU_ITEM_LOGOUT = 1;
export const MENU_ITEM_ORDERS = 2;

export const TABLE_TYPE_WALLET_EARNINGS = 0;
export const TABLE_TYPE_ORDERS = 1;
export const TABLE_TYPE_SUPPORT_LIST = 2;
export const TABLE_TYPE_RETAILERS = 3;
export const TABLE_TYPE_REFERALS = 4;

export const PROFILE_DOB_MIN_AGE = 18;

//to display in UI
export const POINTS_FILTER = {
  WEEK: "Last 7 Days",
  MONTH: "Last 30 Days",
  QUARTER: "Last 90 Days",
};

//to send to api
export const POINTS_FILTER_BY = {
  WEEK: "lastSevenDays",
  MONTH: "last30Days",
  QUARTER: "last90Days",
};

export const STATUS_TEST = {
  PENDING: "Pending",
  SUCCESS: "Success",
  FAILED: "Failed",
  RESOLVED: "Resolved",
  OPEN: "Open",
};

export const STATUS_TYPE = {
  PENDING: 0,
  SUCCESS: 1,
  FAILED: 2,
  OPEN: 3,
};

export const COINS_HISTORY_REDEEMED = "Redeemed";
export const COINS_HISTORY_EARNINGS = "Earned";

export const EARNING_TYPE_PROFILE = "Profile";

export const SUPPORT_DESCRIPTION_MAX_LEGTH = 50;

export const PROFILE_SETTINGS_FIELD = {
  FIRST_NAME: 0,
  LAST_NAME: 1,
  ETHNICITY: 2,
  POSTCODE: 3,
  MOBILE: 4,
  DOB: 5,
  EMAIL: 6,
  ADDRESS: 7,
  GENDER: 8,
  MARITAL: 9,
  COUNTRY: 10,
};

export const TICKET_TYPE = {
  OPEN: "Open",
  RESOLVED: "Resolved",
};

export const SNACKBAR_TYPE = {
  ERROR: 0,
  SUCCESS: 1,
};

export const MEDIA_SIZES = {
  mobile: "576px",
  tablet: "768px",
  laptop: "1024px",
  desktop: "2560px",
  mediumMobile: "425px",
  smallMobile: "320px",
};

export const PROFILE_SETTINGS_TYPE_TEXT = 0;
export const PROFILE_SETTINGS_TYPE_GENDER = 1;
export const PROFILE_SETTINGS_TYPE_MARITAL = 2;
export const PROFILE_SETTINGS_TYPE_DOB = 3;
export const PROFILE_SETTINGS_TYPE_ETHNICITY = 4;
export const PROFILE_SETTINGS_TYPE_MOBILE = 5;
export const PROFILE_SETTINGS_TYPE_ADDRESS = 6;
export const PROFILE_SETTINGS_TYPE_COUNTRY = 7;

export const USER_INVITATION_MASTER_CODE = 2;

export const COUPONS_PER_ROW = 4;
export const COUPON_ROWS_DEFAULT = 2;
export const COUPON_ROWS_AFTER_SHOW_MORE = 4;

export const ALLOWED_COUNTRY_LIST = ["UK", "GB", "IN"];

export const SURVEY_STATUS = {
  COMPLETED: "Completed",
  FAILED: "Failed",
};

export const SURVEY_REWARD_BANNER = {
  HEADING: "Tell Us About You & Earn More Rewards!",
  DESCRIPTION:
    "Answer a few quick questions to get personalized surveys tailored to you. The more relevant your surveys, the more rewards you can earn",
  BUTTON_LABEL: "Start Now",
};

export const SURVEY_QUESTIONS = {
  QUESTIONS: "Questions",
  ERROR_MESSAGE: "Please select an answer to continue",
  NOTE: "Note: Maximum of 50 responses allowed per day.",
  NEXT_BUTTON_LABEL: "Next",
  CHANGE_CATEGORY_BUTTON_LABEL: "Change Category",
  NEXT_QUESTION_BUTTON_LABEL: "Next Question",
  DIALOG_HEADING: "You did it!",
  DIALOG_DESCRIPTION: "You've completed 10 questions!",
  DIALOG_LIMIT_REACHED_HEADING: "You’ve reached your daily Limit!",
  DIALOG_LIMIT_REACHED_DESCRIPTION:
    "You’ve answered 50 questions today — great job! More will be available tomorrow. Keep it up!",
  HOME_BUTTON_LABEL: "Go to Home",
};

export const SURVEY_BUTTONS = {
  NEXT_BUTTON_LABEL: "Next",
  FINISH_BUTTON_LABEL: "Finish",
  CANCEL_BUTTON_LABEL: "Cancel",
  BACK_BUTTON_LABEL: "Back",
  FIND_SURVEYS_NOW_BUTTON_LABEL: "Find Surveys Now",
};

export const REWARD_SURVEY = {
  HEADING: "Let’s Personalize Your Surveys!",
  PARAGRAPH:
    "Help us match you with surveys that fit your interests & earn more rewards!",
  COMPLETED_SURVEY_HEADING: "You’re All Set!",
  COMPLETED_SURVEY_PARAGRAPH:
    "We’ve customized your surveys. Start earning rewards now!",
};

export const SURVEY_MATCH_POPUP = {
  HEADING: "This is a good match!",
  CLOSE_ICON_LABEL: "close",
  START_BUTTON_TEXT: "Start Here",
};

export const SURVEY_POPUP = {
  TITLE: "Important things to know about taking surveys",
  DESCRIPTION:
    "We award qualified participants who meet all survey requirements and comply with our Terms. Some may not qualify based on response content or survey needs, or may be disqualified for incomplete, inconsistent, or suspect (e.g., high-speed) responses. Survey partner determines if an award issues. See FAQs for additional info.",
  BUTTON_TEXT: "Continue to Surveys",
};

// Toluna rejection type IDs (RespondentRejectionTypeID / rejectionID query param)
// that indicate a genuine disqualification (as opposed to e.g. quota-full),
// eligible for the consolation "disqualified reward" popup.
export const DISQUALIFIED_REJECTION_IDS = [14, 123, 124];

export const DISQUALIFIED_REWARD_POINTS = 5;

export const DISQUALIFIED_REWARD_POPUP = {
  HEADING: "We are sorry!",
  POINTS_LABEL: `${DISQUALIFIED_REWARD_POINTS} Points`,
  MESSAGE_1: `Clearly it wasn’t a match, however you have been given ${DISQUALIFIED_REWARD_POINTS} points for taking the time to start the survey.`,
  MESSAGE_2:
    "We have looked and can see there are other opportunities for you to earn.",
  START_SURVEY_BUTTON_TEXT: "Start Survey",
  CLOSE_BUTTON_TEXT: "Go to Surveys",
};

// Option texts that should be treated as a "prefer not to answer" style
// response on prescreener/survey-profiler questions.
export const PREFER_NOT_TO_ANSWER_OPTIONS = [
  "prefer not to answer",
  "i prefer not to answer",
  "not sure/prefer not to say",
  "prefer not to say",
];

export const PREFER_NOT_TO_ANSWER_POPUP = {
  HEADING: "Want more survey matches?",
  DESCRIPTION:
    "Answering this question helps us match you with more surveys you're eligible for, it only takes a second.",
  CHANGE_ANSWER_BUTTON_TEXT: "Choose a Different Answer",
  CONTINUE_BUTTON_TEXT: "Continue Anyway",
};
